/* eslint-disable max-len */
const allGlitches = [
  require("../../../provision/glitches/animate/animate.json"),
  require("../../../provision/glitches/bouncify/bouncify.json"),
  require("../../../provision/glitches/break in half/break in half.json"),
  require("../../../provision/glitches/chase/chase.json"),
  require("../../../provision/glitches/collectible/collectible.json"),
  require("../../../provision/glitches/cycle/cycle.json"),
  require("../../../provision/glitches/dizzy/dizzy.json"),
  require("../../../provision/glitches/drive/drive.json"),
  require("../../../provision/glitches/effects/effects.json"),
  require("../../../provision/glitches/elevator/elevator.json"),
  require("../../../provision/glitches/finish-line/finish-line.json"),
  require("../../../provision/glitches/friction/friction.json"),
  require("../../../provision/glitches/grid_layout/grid_layout.json"),
  require("../../../provision/glitches/gravity/gravity.json"),
  require("../../../provision/glitches/hazard/hazard.json"),

  require("../../../provision/glitches/invulnerable/invulnerable.json"),
  require("../../../provision/glitches/jump/jump.json"),
  require("../../../provision/glitches/pin in place/pin in place.json"),
  require("../../../provision/glitches/projectile/projectile.json"),
  require("../../../provision/glitches/left-right/left-right.json"),
  require("../../../provision/glitches/portal/portal.json"),
  require("../../../provision/glitches/retry/retry.json"),
  require("../../../provision/glitches/screenwrap/screenwrap.json"),
  require("../../../provision/glitches/spawn/spawn.json"),
  require("../../../provision/glitches/visibility/visibility.json"),
  require("../../../provision/glitches/walk/walk.json"),
  require("../../../provision/glitches/wall/wall.json"),

  //TODO
  require("../../../provision/glitches/wander/wander.json"),

  require("../../../provision/glitches/builtin_physics/builtin_physics.json"),
];

/*
  require('../../../provision/glitches/spawn/spawn.json'),
  Should 'spawn' go on the spawn point or the object that spawns?

  require('../../../provision/glitches/accelerate/accelerate.json'),
  Accelerate currently does nothing.  There is an open question about what it should do and how to implement.
  Accelerate goes on an object.  when another object touches it, it accelerates the other object in a direction.
  
  Should that direction be the direction the object is moving, or should it be a fixed direction?

  If it is a fixed direction, should that direction be set in the glitch, or should it be set in the object?
  How do display it?


*/

let availableGlitches = allGlitches;

module.exports = availableGlitches;
